import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDayTripPlanCheckInAvailableDayOfTheWeek } from "./check-in-available-day-of-the-week";
import { QuestionPlanRequiredPrepMillisecond } from "./required-prep-milli-second";
import { QuestionDayTripPlanSaleStartBeforeDate } from "./sale-start-before-date";
import { QuestionDayTripPlanSaleTerm } from "./sale-term";
import { QuestionDayTripPlanStayableDayOfTheWeek } from "./stayable-day-of-the-week";
import { useDayTripPlanScConnected } from "../price-and-policy/sc-connected";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	term: DayTripPlanCategoriesAndManagerStore["term"];
};

export const QuestionDayTripPlanTerm = ({ term }: Props) => {
	const { isSCConnected } = useDayTripPlanScConnected();

	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="期間の制限" categoryStore={term}>
				<div className="space-y-4">
					{isSCConnected?.value && (
						<p className="text-error-600">
							サイトコントローラー連携中でも販売期間を設定できます。
							<br />
							ただし、この期間はサイトコントローラー側には反映されず、CHILLNN上でのみ有効です。
						</p>
					)}
					<QuestionDayTripPlanSaleTerm />
				</div>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="曜日の制限" categoryStore={term}>
				<div className="space-y-4">
					{isSCConnected?.value && (
						<p className="text-error-600">
							サイトコントローラー連携中でも曜日の制限を設定できます。
							<br />
							ただし、この制限はサイトコントローラー側には反映されず、CHILLNN上でのみ有効です。
						</p>
					)}
					<QuestionDayTripPlanStayableDayOfTheWeek />
					<QuestionDayTripPlanCheckInAvailableDayOfTheWeek />
				</div>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="時間の制限" categoryStore={term}>
				<QuestionDayTripPlanSaleStartBeforeDate />
				<QuestionPlanRequiredPrepMillisecond />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionDayTripPlanTerm.displayName = "QuestionDayTripPlanTerm";
